import React from "react";
import ContactModal from "../Modals/ContactModal";
import StarRating from "components/StarRating";
import Button from "components/UI/Button";
import SlideSwitch from "components/SlideSwitch";
import { toast } from "react-toastify";
import axios from "axios";
import { API_URL, ERROR_HANDLE } from "config/constants";
import * as jsPDF from "jspdf";
import ReactTooltip from "react-tooltip";

class GymMenu extends React.Component {
  state = {
    pic: "",
    qr: "",
    available: this.props.available,
    test: this.props.test,
    images: [],
    contactModal: false
  };
  ProfilePicSelected = e => {
    if (e.target.files) {
      // this.uploadPic(e.target.files[0], this.props.gymid);
      this.uploadPic(e.target.files[0], this.props.gymid, "image");
    }
  };
  CoverPicsSelected = e => {
    if (e.target.files) {
      this.uploadPic(e.target.files[0], this.props.gymid, "cover");
    }
  };
  uploadPic = (file, gymid, kind) => {
    const toastId = toast("Uploading Image...");
    const access_token = localStorage.getItem("access_token");
    const data = new FormData();
    data.append("image", file);
    axios
      .post(`${API_URL}/admin/gyms/profile/${kind}/${gymid}`, data, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        if (kind === "cover") {
          this.setState({
            ...this.state,
            images: [res.data.image, ...this.state.images]
          });
        } else {
          this.setState({
            ...this.state,
            pic: `${this.state.pic}?=${new Date().getTime()}`
          });
        }

        toast.dismiss(toastId);
        window.location.reload();
      })
      .catch(err => {
        toast.dismiss(toastId);

        ERROR_HANDLE(err);
      });
  };
  handleTestSlideSwitch = () => {
    const access_token = localStorage.getItem("access_token");
    axios
      .post(
        `${API_URL}/admin/gyms/changeTestEnablement/${this.props.gymid}`,
        { status: !this.state.test },
        {
          headers: {
            "x-access-token": access_token
          }
        }
      )
      .then(res => {
        this.props.gym.is_test_enabled = this.state.test
        toast("Status Changed", { autoClose: 500 });
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
    this.setState({ test: !this.state.test });
  }
  handleSlideSwitch = () => {
    const access_token = localStorage.getItem("access_token");
    axios
      .post(
        `${API_URL}/admin/gyms/changeStatus/${this.props.gymid}`,
        { status: !this.state.available },
        {
          headers: {
            "x-access-token": access_token
          }
        }
      )
      .then(res => {
        this.props.gym.is_available = this.state.available
        toast("Status Changed", { autoClose: 500 });
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
    this.setState({ available: !this.state.available });
  };
  toggleContactModal = () => {
    this.setState({ contactModal: !this.state.contactModal });
  };
  componentWillReceiveProps(nextProps) {
    if (nextProps.available !== this.props.available) {
      let pic = "https://via.placeholder.com/283x283";
      if (nextProps.pic !== "")
        pic = `${nextProps.pic}?=${new Date().getTime()}`;
      this.setState({
        pic,
        available: nextProps.available,
        test: nextProps.test,
        images: nextProps.images,
        qr: nextProps.qr
      });
    }
  }

  ImagetoPrint(source) {
    const profilesrc = require("assets/images/flexit-print-logo.png");
    const regsrc = require("assets/fonts/GlacialIndifference-Regular.woff2");
    const reg1src = require("assets/fonts/GlacialIndifference-Regular.woff");
    const boldsrc = require("assets/fonts/GlacialIndifference-Bold.woff2");
    const bold1src = require("assets/fonts/GlacialIndifference-Bold.woff");

    return `<html>
            <head>
            <title>GYM QR</title>
            <style>
            @font-face {
              font-family: 'Glacial Indifference';
              src: url('${regsrc}') format('woff2'),
                  url('${reg1src}') format('woff');
              font-weight: normal;
              font-style: normal;
          }
          @font-face {
              font-family: 'Glacial Indifference';
              src: url('${boldsrc}') format('woff2'),
                  url('${bold1src}') format('woff');
              font-weight: bold;
              font-style: normal;
          }
            </style>
            
              <script>  
              function step1(){
                setTimeout('step2()', 2000);
              }
              function step2(){
                window.print();window.close()
              }
              </script>
            </head>
            <body style='display:flex; flex-direction:column; align-items:center; justify-content:center; font-family: sans-serif; background-color: black; color: white; font-family: Glacial Indifference;'>
            <img
          src='${profilesrc}'
          style='max-width: 400px'
          alt="Logo Dark"
        /><br/><br/>
            <h3 style='font-weight: bold; letter-spacing: 5px'>USE YOUR APP TO SCAN THIS CODE<br/>TO START OR END YOUR WORKOUT</h3>
            <br/><br/>
            <img src='${source}' width='200px' height='200px' style='background-color: white; padding: 10px; border-radius: 20px '/>
            <br/><br/><h4 style='font-weight: normal; letter-spacing: 5px'>FOLLOW US ON INSTAGRAM @FLEXIT_FITNESS</h4>
            </body>
            </html>`;
  }

  displayQR(src) {
    var pwa = window.open("about:blank", "_new");
    pwa.document.open();
    pwa.document.write(this.ImagetoPrint(src));
    pwa.document.close();
  }

  getDataURI(src) {
    return new Promise((resolve, reject) => {
      fetch(src)
        .then(response => response.blob())
        .then(blob => {
          let reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = function() {
            resolve(reader.result);
          };
        })
        .catch(() => {
          reject("Opps! Failed getting Data URI");
        });
    });
  }

  pdfQR(src, name) {
    const toastId = toast.info("Generating Gym QR. Please wait...");
    const qrframe = require("assets/images/qr-frame.min.png");
    this.getDataURI(qrframe)
      .then(qrframedatauri => {
        this.svg2png(src)
          .then(qrdatauri => {
            this.generatePDF(qrframedatauri, qrdatauri, name);
            // this.displayQR(src); // The Image opens in the webview is HTML. That needs to be changed later.
            toast.dismiss(toastId);
          })
          .catch(() => {
            toast.dismiss(toastId);
          });
      })
      .catch(() => {
        toast.dismiss(toastId);
      });
  }

  svg2png(src) {
    return new Promise(resolve => {
      fetch(src)
        .then(res => res.text())
        .then(text => {
          let parser = new DOMParser();
          let oDOM = parser.parseFromString(text, "application/xml");
          if (oDOM.documentElement.nodeName !== "parsererror") {
            let svgData = new XMLSerializer().serializeToString(
              oDOM.documentElement
            );
            let canvas = document.createElement("canvas");
            canvas.width = 500;
            canvas.height = 500;
            let img = document.createElement("img");
            img.setAttribute(
              "src",
              "data:image/svg+xml;base64," + btoa(svgData)
            );

            img.onload = () => {
              canvas.getContext("2d").drawImage(img, 0, 0, 500, 500);
              let qrcodedatauri = canvas.toDataURL("image/png");
              resolve(qrcodedatauri);
            };
          }
        });
    });
  }

  generatePDF(image1, image2, name) {
    let doc = new jsPDF();
    doc.setFillColor("#272727");
    doc.rect(0, 0, 210, 300, "F");
    doc.addImage(image1, "PNG", 0, 40, 210, 210);
    doc.addImage(image2, "PNG", 68, 132, 75, 75);
    doc.save(`${name}-GYMQR.pdf`);
  }

  saveGymName(gym_name) {
    axios
      .put(
        `${API_URL}/admin/gyms/${this.props.gymid}`,
        { gym_name },
        {
          headers: {
            "x-access-token": localStorage.getItem("access_token")
          }
        }
      )

      .then(res => {
        console.log("Name Edit Blurred");
        this.props.gym.gym_name = gym_name
        this.setState({
          ...this.state,
          editName: false,
          gymName: gym_name
        });
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  }

  render() {
    let { name, rating, city } = this.props;
    let { pic, qr, images } = this.state;
    const acl = localStorage.getItem("restricted_access");
    if (pic) {
      if (pic === "") pic = "https://via.placeholder.com/283x283";
    } else pic = "https://via.placeholder.com/283x283";

    return (
      <div style={style.wrapper}>
        {this.state.contactModal && (
          <ContactModal
            onClick={this.toggleContactModal}
            gymid={this.props.gymid}
          />
        )}
        <div style={style.profileImage}>
          <img
            src={pic}
            alt="Profile"
            style={{ objectFit: "cover", width: "280px", height: "280px" }}
          />
          <a>
            <div
              style={style.profileImageOverlay}
              onClick={() => {
                document.getElementById("editImageInput").click();
              }}
            >
              <input
                type="file"
                id="editImageInput"
                accept="image/*"
                name="ProfilePic"
                style={{ display: "none" }}
                onChange={this.ProfilePicSelected}
              />
              <p style={style.overlayText}>Edit Logo</p>
            </div>
          </a>
        </div>
        <div style={style.gymActionWrapper}>
          <div style={style.headingWrapper}>
            <div>
              <div>
                {this.state.editName ? (
                  <div style={{ ...style.wrapper, alignItems: "center" }}>
                    <input
                      style={style.gymNameEdit}
                      type="text"
                      autoFocus
                      onChange={e => {
                        this.setState({
                          ...this.state,
                          gymName: e.target.value
                        });
                      }}
                      onKeyDown={e => {
                        if (e.keyCode == 13) {
                          localStorage.setItem("gymName", e.target.value);
                          if (e.target.value.length > 0) {
                            this.saveGymName(localStorage.getItem("gymName"));
                          }
                        }
                      }}
                      onFocus={e => {
                        e.target.value = this.state.gymName;
                      }}
                      onBlur={e => {
                        localStorage.setItem("gymName", e.target.value);
                        if (e.target.value.length > 0) {
                          this.saveGymName(localStorage.getItem("gymName"));
                        }
                      }}
                    />
                    <sup
                      style={style.editButton}
                      onClick={() => {
                        this.saveGymName(this.state.gymName);
                      }}
                    >
                      Save
                    </sup>
                  </div>
                ) : (
                  <div style={{ ...style.wrapper, alignItems: "center" }}>
                    <p
                      data-tip="Double Click To Edit"
                      style={style.gymName}
                      onDoubleClick={e => {
                        this.setState({
                          ...this.state,
                          editName: true,
                          gymName: e.target.innerHTML
                        });
                        console.log(this.state);
                        // e.target = <input type="text" value={name} />;
                      }}
                      onLoadedData={e => {
                        console.log("gymNameis ", e.target.innerHTML);
                        this.setState({
                          ...this.state,
                          gymName: e.target.innerHTML
                        });
                      }}
                    >
                      {this.state.gymName ? this.state.gymName : name}
                    </p>
                    <sup
                      style={style.editButton}
                      onClick={() => {
                        this.setState({
                          ...this.state,
                          editName: true,
                          gymName: this.state.gymName
                            ? this.state.gymName
                            : name
                        });
                      }}
                    >
                      Edit
                    </sup>
                  </div>
                )}
                <ReactTooltip />
              </div>
              <div style={style.gymRating}>
                <p style={style.ratingText}>{rating ? `${rating}.0` : "0.0"}</p>{" "}
                <StarRating readonly initialRating={rating} />
              </div>
              <div style={style.locationWrapper}>
                <p style={style.locationText}>{city}</p>
              </div>
            </div>
            {acl==="false" ? <div style={style.sliderWrapper}>
              <p style={style.sliderTitle}>Active</p>
              <SlideSwitch
                checked={this.state.available}
                onClick={this.handleSlideSwitch}
              />
            </div>: null}
            {acl==="false" ? <div style={style.sliderWrapper}>
              <p style={style.sliderTitle}>Test</p>
              <SlideSwitch
                checked={this.state.test}
                onClick={this.handleTestSlideSwitch}
              />
            </div>: null}
          </div>
          <div style={style.actionButtons}>
            {/* <div style={style.actionButtonsItem}>
              <Button
                type="primary"
                style={{ fontSize: '18px' }}
                grey
                onClick={() => {
                  this.pdfQR(qr, name);
                }}
              >
                QR PDF
              </Button>
            </div> */}
            <div style={style.actionButtonsItem}>
              <Button
                type="primary"
                style={{ fontSize: "18px" }}
                grey
                onClick={() => {
                  // this.printQR(qr);
                  this.pdfQR(qr, name);
                }}
              >
                QR Code
              </Button>
            </div>
            {acl==="false" ? <div style={style.actionButtonsItem}>
              <Button
                style={{ fontSize: "18px" }}
                type="primary"
                onClick={this.toggleContactModal}
              >
                Contact
              </Button>
            </div>: null}
            {acl==="false" ? <div style={style.actionButtonsItem}>
              <Button
                style={{ fontSize: "18px" }}
                type="primary"
                onClick={() => {
                  if (
                    window.confirm(
                      "Confirm Refresh QR Code For Gym.\nThis Action Cannot Be Reversed."
                    )
                  ) {
                    const toastId = toast("Refreshing QR Code...");
                    const access_token = localStorage.getItem("access_token");
                    axios
                      .get(
                        `${API_URL}/admin/gyms/refresh_qr/${this.props.gymid}`,

                        {
                          headers: {
                            "x-access-token": access_token
                          }
                        }
                      )
                      .then(res => {
                        toast("QR Changed", { autoClose: 500 });
                        toast.dismiss(toastId);
                      })
                      .catch(err => {
                        ERROR_HANDLE(err);
                        toast.dismiss(toastId);
                      });
                  }
                }}
              >
                Refresh QR
              </Button>
            </div> : null}

            <div style={{ flex: 2 }} />
          </div>
        </div>
        <div>
          <div style={style.galleryGridRow}>
            <img
              style={style.galleryGridImage}
              src={
                images && images[0]
                  ? images[0]
                  : "https://via.placeholder.com/140x140"
              }
              alt="Gallery"
              onClick={this.props.galleryTrigger}
            />
            <img
              style={style.galleryGridImage}
              src={
                images && images[1]
                  ? images[1]
                  : "https://via.placeholder.com/140x140"
              }
              alt="Gallery"
              onClick={this.props.galleryTrigger}
            />
          </div>
          <div style={style.galleryGridRow}>
            <img
              style={style.galleryGridImage}
              src={
                images && images[2]
                  ? images[2]
                  : "https://via.placeholder.com/140x140"
              }
              alt="Gallery"
              onClick={this.props.galleryTrigger}
            />
            <div
              style={{
                ...style.perfectlyBalanced,
                cursor: "pointer",
                width: "140px",
                height: "140px",
                backgroundColor: "rgba(0, 0, 0, 0.58)",
                color: "white"
              }}
              onClick={() => {
                document.getElementById("addMorePhotosInput").click();
              }}
            >
              <input
                type="file"
                id="addMorePhotosInput"
                accept="image/*"
                name="Cover"
                style={{ display: "none" }}
                onChange={this.CoverPicsSelected}
              />
              <p style={style.addPhotoText}>+ Add More Photos</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GymMenu;

const style = {
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "#fff",
    padding: "10px"
  },
  profileImage: {
    position: "relative",
    padding: "0px",
    margin: "0px"
  },
  profileImageOverlay: {
    position: "absolute",
    left: "0px",
    right: "0px",
    bottom: "15px",
    height: "50px",
    backgroundColor: "rgba(0, 0, 0, 0.58)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    cursor: "pointer"
  },
  overlayText: {
    color: "#ffffff"
  },
  galleryGridRow: {
    margin: "0px",
    padding: "0px",
    display: "flex"
  },
  galleryGridImage: {
    margin: "1px",
    padding: "0px",
    width: "140px",
    height: "140px",
    objectFit: "cover"
  },
  perfectlyBalanced: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  addPhotoText: {
    color: "#00b4d2"
  },
  gymName: {
    fontSize: "50px",
    // lineHeight: '0.66',
    textAlign: "left",
    color: "#444445",
    margin: "0px",
    marginTop: "10px",
    cursor: "pointer"
  },
  gymNameEdit: {
    fontSize: "30px",
    // lineHeight: '0.66',
    textAlign: "left",
    color: "#444445",
    margin: "0px",
    marginTop: "8px"
  },
  gymRating: {
    display: "flex",
    alignItems: "flex-start"
  },
  ratingText: {
    fontSize: "25px",
    margin: "2px",
    marginLeft: "10px"
  },
  actionButtons: {
    display: "flex",
    alignSelf: "flex-end",
    marginTop: "80px"
    // flexDirection:'row'
  },
  gymActionWrapper: {
    width: "100%",
    paddingLeft: "50px"
  },
  actionButtonsItem: {
    flex: 1.5,
    margin: "5px"
  },
  headingWrapper: {
    display: "flex"
  },
  sliderWrapper: {
    margin: "40px"
  },
  sliderTitle: {
    color: "#444445",
    fontSize: "20px",
    margin: "0px"
  },
  locationText: {
    textAlign: "left",
    fontSize: "20px",
    margin: "5px 10px"
  },
  editButton: {
    fontSize: "14px",
    color: "#454545",
    marginLeft: "6px",
    marginTop: "-16px",
    cursor: "pointer"
  }
};
